import React from "react";
import PageIntro from "../../components/PageIntro";
import { heroContent } from "./homeContent";

/**
 * Opening statement of the page: the H1 and the introduction.
 * Sits directly beneath the banner video, which carries no copy of its own.
 * Presentation lives in the shared PageIntro panel; the copy is unchanged.
 */
const HomeIntro = () => (
  <PageIntro
    id="home-intro-heading"
    title={heroContent.h1}
    paragraphs={heroContent.paragraphs}
    images={[
      "/assets/intro/certification-compliance.webp",
      "/assets/intro/global-standards.webp",
      "/assets/intro/business-growth.webp",
    ]}
    cta={heroContent.cta}
    /* no orange rule under this heading on the Home page (2026-09-28) */
    rule={false}
  />
);

export default HomeIntro;
